import { PrimaryContainer } from '../mui/PrimaryContainer';
import AddDriverTab from '../tabs/AddDriverTab/AddDriverTab';

const AddDriver = () => {

  return (
    <PrimaryContainer>
      <AddDriverTab />
    </PrimaryContainer>
  )
}

export default AddDriver